import { render, staticRenderFns } from "./eInvoiceForm.vue?vue&type=template&id=987a0498&scoped=true"
import script from "./eInvoiceForm.vue?vue&type=script&lang=js"
export * from "./eInvoiceForm.vue?vue&type=script&lang=js"
import style0 from "./eInvoiceForm.vue?vue&type=style&index=0&id=987a0498&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987a0498",
  null
  
)

export default component.exports